import { Alert, ListItem, styled } from "@mui/material";
import React, { useEffect, useState } from "react";
import { SelectFieldComponent, TextFieldComponent } from "../../external/ensolvers-core-frontend-mui/components/Common/FormComponents";
import { ListComponentWithIcon } from "../ListComponentWithIcon";
import { SpinnerWrapper } from "../SpinnerWrapper";
import TextScrollX from "../TextScrollX";
import { Accomplishment } from "../../models/Accomplishment";
import { Box, Typography } from "@material-ui/core";
import AssignationService from "../../services/AssignationService";
import AutoCompleteUIDTO, { EMPTY_AUTOCOMPLETE } from "../../dto/AutoCompleteUIDTO";
import ApiResponse from "../../external/ensolvers-core-frontend-mui/submodules/fox-typescript/core/ApiResponse";
import NotificationService from "../../external/ensolvers-core-frontend-mui/submodules/fox-typescript/services/NotificationService";
import { DateFieldComponent } from "../DatePicker";
import AccomplishmentService from "../../services/AccomplishmentService";
import { AccomplishmentType } from "../../models/AccomplishmentType";

interface Props {
  isLoading: boolean;
  register: any;
  control: any;
  errors: any;
  instance: Accomplishment;
  setLinks: (links: string[]) => void;
  links: string[];
}

export default function AccomplishmentCreateModal(props: Props) {
  const [roleText, setRoleText] = useState();
  const [userAssignations, setUserAssignations] = useState<AutoCompleteUIDTO[]>();
  const [accomplishmentTypes, setAccomplishmentTypes] = useState<AccomplishmentType[]>();
  const [selectedType, setSelectedType] = useState<AccomplishmentType>();

  useEffect(() => {
    loadAssignationNames();
    getAccomplishmentTypes();
  }, []);

  useEffect(() => {
    if (roleText) {
      const type = getAccomplishmentData(roleText);
      setSelectedType(type!);
    }
  }, [roleText]);

  const getAccomplishmentTypes = async () => {
    try {
      const response = await AccomplishmentService.getTypes();
      setAccomplishmentTypes(response.getContentOrThrowError());
    } catch (error) {
      NotificationService.error("Error getting accomplishment types");
    }
  };

  const loadAssignationNames = async (date: Date | null = null) => {
    try {
      const response: ApiResponse<AutoCompleteUIDTO[]> = await AssignationService.findAssignationsNamesByUser(undefined, date);
      const responseContent: AutoCompleteUIDTO[] = response.getContent();
      setUserAssignations(responseContent);
    } catch (error) {
      NotificationService.error("Error getting positions");
    }
  };

  const getAccomplishmentData = (externalId: string) => {
    return accomplishmentTypes?.find((t) => t.externalId === externalId);
  };

  return (
    <>
      <SpinnerWrapper isLoading={props.isLoading}>
        <SelectFieldComponent
          control={props.control}
          register={props.register}
          errors={props.errors}
          propertyName={"type.externalId"}
          label={"Type"}
          required={true}
          options={
            accomplishmentTypes
              ? accomplishmentTypes?.map((t) => {
                  return { label: t.title, value: t.externalId! };
                })
              : []
          }
          customHelperText={"some text"}
          internalSelectProps={{
            onChange: (event: any) => {
              setRoleText(event.target.value);
            },
          }}
        />
        <SelectFieldComponent
          control={props.control}
          register={props.register}
          errors={props.errors}
          propertyName={"assignation.externalId"}
          label={"Role"}
          required={false}
          options={
            userAssignations
              ? [
                  { label: "No role", value: "No role" },
                  ...userAssignations.map((a) => {
                    return { label: a.label, value: a.externalId };
                  }),
                ]
              : []
          }
        />
        {roleText !== undefined && (
          <Alert severity="info">
            <Typography style={{ fontWeight: "bold" }}>{"Approval conditions"}</Typography>
            <Typography>
              {selectedType?.approvalConditions}
              {selectedType?.additionalInfo?.map((i) => (
                <>
                  <ListItem children={`- ${i}`} />
                </>
              ))}
            </Typography>
            <br />
            <Typography style={{ fontWeight: "bold" }}>{"Approval accreditation data"}</Typography>
            <Typography>{selectedType?.approvalAccreditationData}</Typography>
            <br />
            <Typography style={{ fontWeight: "bold" }}>{"Approval needed by"}</Typography>
            <Typography>{selectedType?.approvalBy}</Typography>
            <br />
            <Typography style={{ fontWeight: "bold" }}>{"Points"}</Typography>
            <Typography>{selectedType?.points}</Typography>
          </Alert>
        )}

        <DateFieldComponent
          control={props.control}
          register={props.register}
          errors={props.errors}
          propertyName={"reportedOn"}
          label="Performed on"
          required={true}
          clearable={true}
          toUTC
        />

        <ListComponentWithIcon
          title={"Additional info"}
          name="links-accomplishment"
          items={props.links}
          renderItem={(item, index) => <TextScrollX key={index}>• {item}</TextScrollX>}
          onAdd={(newItem: string) => props.setLinks([...props.links, newItem])}
          onDelete={(itemIndex) => props.setLinks(props.links.filter((item, index) => index !== itemIndex))}
        />
      </SpinnerWrapper>
    </>
  );
}

const Input = styled("input")({
  display: "none",
});
